/*
 * Copyright (c) GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import { Injectable } from '@angular/core';

import { AuthenticationService } from '../authentication/authentication.service';
import {isNotNull} from '@fabric/common/utilities';
import{VacationTrackerUser} from './vacation-tracker-user';


@Injectable({
  providedIn: 'root',
})
export class UserService {
  public user: VacationTrackerUser | null = null;

  constructor(private readonly authenticationService: AuthenticationService) {
    // Construct the UserProfile object
    this.createUser();
  }

  /**
   * Test to see if the current user has any of the provided authorities
   *
   * @param requiredAuthorities Array of authority names
   */
  public hasAnyAuthorities(requiredAuthorities: string[]): boolean {
    for (const authority of requiredAuthorities) {
      if (isNotNull(authority) && this.user?.authorities && this.user.authorities.indexOf(authority) > -1) {
        return true;
      }
    }
    return false;
  }

  /**
   * Test if the current user has the provided authority.
   *
   * @param requiredAuthority Authority name
   */
  public hasAuthority(requiredAuthority: string): boolean {
    return this.hasAnyAuthorities([requiredAuthority]);
  }

  /**
   * Check to see if the current user has the provided role.
   *
   * @param requiredRole Role name
   */
  public hasRole(requiredRole: string): boolean {
    return this.user?.roles ? this.user.roles.indexOf(requiredRole) > -1 : false;
  }

  private createUser(): void {
    const user = this.authenticationService.userInfo;
    if (user) {
      this.user = user;

      this.user.roles = this.user.roles ?? ['GENERAL_USER'];

      this.user.authorities = ['general-user'];

      if (this.hasRole('abt_hr')){
        this.user.authorities.push('hr');
      }

      if (this.hasRole('abt_manager') || this.hasRole('Managers_IRL_Autopop')){
        this.user.authorities.push('manager');
      }
    }
  }
}
